import { render, staticRenderFns } from "./InfoWeCalculated.vue?vue&type=template&id=2e9b264d&scoped=true"
import script from "./InfoWeCalculated.vue?vue&type=script&lang=ts"
export * from "./InfoWeCalculated.vue?vue&type=script&lang=ts"
import style0 from "./InfoWeCalculated.vue?vue&type=style&index=0&id=2e9b264d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9b264d",
  null
  
)

export default component.exports